<script setup>
import {pgettext} from "@/utils/translate";
import {useQuery} from "@vue/apollo-composable";
import {HpoPredefinedDiagnosisListQuery} from "@/graphql/queries/hpo/diagnosis.graphql";
import {useLastResult} from "@/graphql/composable";
import DiagnosisBuilder from "@/components/hpo/patientModal/diagnosis/DiagnosisBuilder.vue";
import {useTemplateRef} from "vue";
import {mdiCloseCircle} from "@mdi/js";

const model = defineModel({type: Boolean});
const props = defineProps({
    diagnosis: String,
});
const emit = defineEmits(['save']);

const builder = useTemplateRef('builder');

const {result, loading, refetch} = useQuery(HpoPredefinedDiagnosisListQuery);
const predefinedDiagnosisList = useLastResult(result, null);

function save() {
    if (!builder.value) {
        return;
    }

    emit('save', {
        diagnosis: builder.value.diagnosisObj.toString(),
    });
}
</script>

<template>
    <v-dialog v-model="model" :persistent="true">
        <v-card>
            <v-card-text>
                <v-container class="pa-0">
                    <DiagnosisBuilder v-if="predefinedDiagnosisList !== null"
                                      ref="builder"
                                      :diagnosis="diagnosis"
                                      :predefined-diagnosis="predefinedDiagnosisList"/>
                    <v-empty-state v-else-if="loading">
                        <template #media>
                            <v-progress-circular indeterminate :size="48" :width="6" color="blue"/>
                        </template>
                    </v-empty-state>
                    <v-empty-state v-else
                                   :icon="mdiCloseCircle"
                                   color="red"
                                   :title="pgettext('title', 'Error while loading list of diagnoses.')"
                                   :action-text="pgettext('action', 'Reload')"
                                   @click:action="refetch"/>
                </v-container>
            </v-card-text>
            <v-card-actions class="bg-surface-light justify-center">
                <v-btn @click="save" class="flex-fill" color="green" variant="flat" size="large">
                    {{ pgettext('action', 'Save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
